export { default as EN } from "./en.json";
export const RULE_TRANSLATIONS_NAMESPACE = "rules";
